import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect x="2" y="4" width="16" height="2" rx="1" fill="#fff" /><rect x="2" y="11.5" width="12" height="2" rx="1" fill="#fff" /><rect x="2" y="19" width="20" height="2" rx="1" fill="#fff" /></svg>;